import React, { useEffect, useState } from "react";
import AppHeader from "@/components/AppHeader";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { BellRinging } from "@phosphor-icons/react";
import { useI18n } from "@/context/I18nContext";

export default function Notifications() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/notifications");
        setItems(data || []);
        await api.post("/notifications/read-all").catch(() => {});
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <AppHeader />
      <main className="max-w-3xl mx-auto px-6 py-10">
        <div className="label-overline text-[#007AFF]">{t("notif.kicker")}</div>
        <h1 className="font-display text-5xl tracking-tight mt-2">{t("notif.title")}</h1>

        <div className="mt-8 border border-[#262626]" data-testid="notifications-list">
          {loading ? (
            <div className="p-6 label-overline">{t("common.loading")}</div>
          ) : items.length === 0 ? (
            <div className="p-10 text-center">
              <BellRinging weight="duotone" size={32} className="mx-auto text-zinc-500" />
              <div className="text-sm text-zinc-400 mt-3">{t("notif.empty")}</div>
            </div>
          ) : items.map((n) => {
            const href = n.activity_id
              ? `/activity/${n.activity_id}${n.kind === "rating_prompt" ? "?rate=1" : ""}`
              : null;
            const isRating = n.kind === "rating_prompt";
            return (
              <div key={n.notification_id} className={`px-5 py-4 border-b border-[#262626] last:border-0 flex items-start gap-3 transition-colors hover:bg-white/5 ${isRating ? "bg-[#FFCC00]/5" : ""}`}>
                <div className={`mt-1 w-2 h-2 rounded-full ${n.read ? "bg-zinc-600" : (isRating ? "bg-[#FFCC00]" : "bg-[#007AFF]")}`} />
                <div className="flex-1 min-w-0">
                  <div className="text-sm">{n.text}</div>
                  <div className="label-overline mt-1">{new Date(n.created_at).toLocaleString()}</div>
                </div>
                {href && (
                  isRating ? (
                    <Link to={href} data-testid={`notif-rate-${n.notification_id}`} className="text-xs px-3 py-1.5 bg-[#FFCC00] hover:bg-[#e6b800] text-black font-bold uppercase tracking-widest">
                      ★ {n.activity_id && "Rate"}
                    </Link>
                  ) : (
                    <Link to={href} className="text-xs text-[#007AFF] hover:underline uppercase tracking-widest">{t("notif.view")}</Link>
                  )
                )}
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
